import { useTheme } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useUserContext } from '../../../contexts/UserContext';
import { getFacilitiesStatusSummary } from '../../../services/company/getFacilitiesStatusSummary';
import { DigitalDossierAside } from '../shared/DigitalDossierAside';
import { ProductiveFacilities } from './ProductiveFacilities';
import { StorageFacilities } from './StorageFacilities';

export const AffidavitsSection = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { userHasPendingChanges, setUserHasPendingChanges } = useUserContext();

  const { data: affidavitsStatus, refetch: refetchStatusSummary } = useQuery({
    queryKey: ['facilities-status-summary'],
    queryFn: getFacilitiesStatusSummary,
  });

  const { productiveFacilitiesStatus, storageFacilitiesStatus } =
    affidavitsStatus ?? {};

  const tabsData = useMemo(() => {
    const tabs = [
      {
        title: t('common.producers'),
        content: (
          <ProductiveFacilities refetchStatusSummary={refetchStatusSummary} />
        ),
        status: productiveFacilitiesStatus,
      },
      {
        title: t('common.stockpiles'),
        content: (
          <StorageFacilities refetchStatusSummary={refetchStatusSummary} />
        ),
        status: storageFacilitiesStatus,
      },
    ];

    return tabs;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productiveFacilitiesStatus, storageFacilitiesStatus]);

  return (
    <DigitalDossierAside
      tabsData={tabsData}
      theme={theme}
      hasUserPendingChanges={userHasPendingChanges}
      setUserHasPendingChanges={setUserHasPendingChanges}
    />
  );
};
